module.exports = __webpack_public_path__ + "img/delete.cdf8e66.svg";